import React, { useEffect } from 'react';
import { useClinicians } from '@features/organizations/store/hooks';
import { Box } from '@mui/material';

import { useOrgScheduleAccess } from '../../hooks/useOrgScheduleAccess';
import { useOrgScheduleFilters } from '../../hooks/useOrgScheduleFilters';

import { OrgSchedulePatientFilter } from './OrgSchedulePatientFilter';
import { OrgScheduleProviderFilter } from './OrgScheduleProviderFilter';

export const OrgScheduleFilterBar: React.FC = () => {
  const { hasOrgScheduleAccess } = useOrgScheduleAccess();
  const {
    selectedProviderIds,
    selectedPatientIds,
    updateSelectedProviders,
    updateSelectedPatients,
    initializeProviders,
  } = useOrgScheduleFilters();
  const { clinicians, isLoading } = useClinicians({ skip: !hasOrgScheduleAccess });

  // Initialize provider selection once clinicians are loaded
  useEffect(() => {
    if (!isLoading && clinicians.length > 0) {
      initializeProviders(clinicians);
    }
  }, [isLoading, clinicians, initializeProviders]);

  if (!hasOrgScheduleAccess) return null;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, pl: 2, mb: 2 }}>
      <OrgSchedulePatientFilter
        selectedPatientIds={selectedPatientIds}
        onSelectionChange={updateSelectedPatients}
      />
      <OrgScheduleProviderFilter
        clinicians={clinicians}
        selectedProviderIds={selectedProviderIds ?? []}
        onSelectionChange={updateSelectedProviders}
        isLoading={isLoading}
      />
    </Box>
  );
};
